import { Request } from "@xt/xtbase";

const { XtAxios4 } = Request;

const IP_API_URL = "/sapi/v4/ip/public/info/ip";

/** 法币国家代码（沙特、巴西、阿联酋） */
const FIAT_COUNTRY_CODES = ["AE", "BR", "SA"] as const;

/** 国家代码 -> 法币代码 */
export const COUNTRY_TO_FIAT_CODE: Record<string, string> = {
  AE: "AED",
  BR: "BRL",
  SA: "SAR",
};

/**
 * 判断当前 IP 是否在三个法币国家范围内（沙特 SA、巴西 BR、阿联酋 AE）
 * @returns Promise<boolean> true 表示在法币国家，false 表示不在或请求失败
 */
export async function getIsIpInFiatCountries(): Promise<boolean> {
  const code = await getFiatCodeByIp();
  return code != null;
}

/**
 * 根据 IP 获取法币代码（仅三国：AE->AED, BR->BRL, SA->SAR）
 * @returns Promise<"AED"|"BRL"|"SAR"|null>
 */
export async function getFiatCodeByIp(): Promise<"AED" | "BRL" | "SAR" | null> {
  try {
    const response = await XtAxios4.get(IP_API_URL);
    const countryCode =
      (response?.countryCode || response?.data?.countryCode)?.toUpperCase?.() || null;
    if (!countryCode || !FIAT_COUNTRY_CODES.includes(countryCode)) return null;
    const fiat = COUNTRY_TO_FIAT_CODE[countryCode];
    return fiat === "AED" || fiat === "BRL" || fiat === "SAR" ? fiat : null;
  } catch (error) {
    console.warn("getFiatCodeByIp failed:", error);
    return null;
  }
}
